@import url("./sellalong-cta.css");

.sellalong-cta-link {
  font-family: var(--sellalong-text-font, serif);
  letter-spacing: 0.06em;
}

.sellalong-cta-action {
  font-family: var(--sellalong-control-font, sans-serif);
  font-size: 11px;
  letter-spacing: 3px;
  margin-left: 8px;
  color: #7e7e7e;
  text-transform: uppercase;
}
